import { React } from "react";
import {BrowserRouter as Router} from "react-router-dom";
import history from './Services/History';
import Routes from './pages/Routes';
import Header from './layout/Header';

import './pages/animation.css';

import './App.css';
function App() {
  return(
    <Router history={history}>
      <Header/>
      <Routes/>
    </Router>
  )
}

export default App;
